import actionTypes from 'app/actions/dictionaries/dictionaries.action-types';

export default (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_SFTP_AUTHENTICATION_TYPES_DICTIONARY_SUCCESS: {
      return { ...action.types };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/reducers/dictionaries/sftp-authentication-types.js